module.exports = __webpack_public_path__ + "img/Subsidios.592a8284.svg";